interface MaybeDestroyable {
  destroy: () => void;
}

export function destroyIfPresent(target: MaybeDestroyable | null | undefined): void {
  if (!target) return;
  try {
    target.destroy();
  } catch (error) {
    console.error('Destroy helper caught teardown error:', error);
  }
}
